import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Card,
  CardBody,
  CardTitle
} from 'reactstrap';
import './etiqueta.styles.css';
import * as acessos from '../../../../../../acessos.const.util';
import IntlMessage from '../../../../../../helpers/intlMessage';

const EtiquetaPage = props => (
  <div className='etiqueta-container'>
    <p className='title'><IntlMessage id = "dashboards.examDetail.printLabels"/></p>
    <Row>
      <Col>
        <FormGroup className='ml1-25rem'>
          <i
            style={{ cursor: 'pointer' }}
            onClick={props.onClickAll}
            className={props.all ? 'far fa-check-square' : 'far fa-square'}
          >
            {' '}
          </i>
          <Label className='checkbox-all' check onClick={props.onClickAll}>
            <IntlMessage id = "dashboards.examDetail.selectAll"/>
          </Label>
        </FormGroup>
      </Col>
      {props.acessoPermitido(props.usuario, acessos.Etiqueta) &&
        props.acessoPermitido(props.usuario, acessos.Etiqueta) && (
          <Col sm={{ size: 'auto', offset: 1 }}>
            <FormGroup>
              <a
                className='mv-basico-imprimir'
                onClick={props.imprimirEtiquetas}
              >
                &nbsp;
              </a>
            </FormGroup>
          </Col>
        )}
    </Row>
    <div
      style={{
        height: `${props.altura - 15}px`,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden'
      }}
    >
      {props.frascoscriados
        .filter(el => !!el.topografia)
        .map(frasco => {
          return (
            <Row key={frasco.frascoId}>
              <Col>
                <Card
                  onClick={() => {
                    props.onClick(frasco.frascoId);
                  }}
                >
                  <Row>
                    <Col sm='1'>
                      <CardBody className='checkbox'>
                        <i
                          className={
                            props.selecionados.indexOf(frasco.frascoId) === -1
                              ? 'far fa-square'
                              : 'far fa-check-square'
                          }
                        ></i>
                      </CardBody>
                    </Col>
                    <Col>
                      <CardBody>
                        <CardTitle><IntlMessage id = "dashboards.examDetail.bottle"/>{`${frasco.dsFrasco} - ${frasco.topografia}`}</CardTitle>
                      </CardBody>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          );
        })}
      {props.frascoscriados.length > 0 && (
        <Row>
          <Col>
            <Card
              onClick={() => {
                props.onClick(0);
              }}
            >
              <Row>
                <Col sm='1'>
                  <CardBody className='checkbox'>
                    <i
                      className={
                        props.selecionados.indexOf(0) === -1
                          ? 'far fa-square'
                          : 'far fa-check-square'
                      }
                    ></i>
                  </CardBody>
                </Col>
                <Col>
                  <CardBody>
                    <CardTitle><IntlMessage id = "dashboards.examDetail.controlLabel"/></CardTitle>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  </div>
);

export default EtiquetaPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/etiqueta/etiqueta.page.js